import React from 'react';
import { Form, Input, Button,Select,DatePicker,Spin,Image, Card,Divider,Result, message } from 'antd';
import axios from 'axios'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import moment from 'moment';
import * as serverconfig from '../../serverconn'
import {
  Col,
  Row,
} from 'reactstrap';
import { UserOutlined, LockOutlined, LoadingOutlined,MailOutlined } from '@ant-design/icons';
var CryptoJS = require("crypto-js");


const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;


var token= ''


class FrontendUpdateSyncForm extends React.Component {

  state = {
    date:moment().format(dateFormat).toString(),
    message:'',
    saccoboject:{}
  }


  componentDidMount(){

    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    this.setState({datarequested:false})
}


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})

    let form_data = new FormData();
    
    form_data.append('client_id', this.props.client_id);
    axios.post(serverconfig.backendserverurl+'/customqueries/frontendupdatesyncronization', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
    .then(res =>{
      console.log(res.data)
      this.setState({datarequested:false})
      //window.location.reload(false)
      this.setState({message:res.data.message})
      this.setState({datasubmittedsuccessfully:true})
    }    
    )
    .catch(error => console.log(error))


  }


  render(){
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{


      if (this.state.datasubmittedsuccessfully===true){
        return(
            <Card>
            <Result
            status="success"
            title={this.state.message}
            extra={[
              <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
            ]}
            />
            </Card>
        );

      }else{

            return (
              <div>
                <h3>Syncrnize frontend changes now</h3>
                <Form onFinish={(event) => this.handleFormSubmit(event)}>

                <FormItem >
                  <Button  type='primary' htmlType="submit">Syncronize</Button>
                </FormItem>
      
                </Form>
              </div>
            );
          }
    }
    
  }

}

export default FrontendUpdateSyncForm;



